import { useState } from 'react'

import DrawerType from '../../../../components/atoms/Drawer'
import PreScheduling from '../../../../components/organisms/PreScheduling'

import { Plus } from 'lucide-react'

import { ActionButton } from '../styles'

export function PreSchedulingButton() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <DrawerType
        open={isOpen}
        setDrowerOpen={setIsOpen}
        content={<PreScheduling />}
      />
      <ActionButton $primary onClick={() => setIsOpen(true)}>
        <Plus size={16} aria-hidden="true" />
        Pré Agendamento
      </ActionButton>
    </>
  )
}
